import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { PhotoProvider } from './context/PhotoContext';
import { LanguageProvider } from './i18n';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LanguageProvider>
      <PhotoProvider>
        <App />
      </PhotoProvider>
    </LanguageProvider>
  </React.StrictMode>
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
